<template>
  <div
    class="modal_wrap full_modal customer_imagemodal"
    :class="{ on: isOpen }"
  >
    <!--'on 추가'-->
    <div class="modal_inner">
      <button class="ie_btn" v-on:click="$emit('close')">
        <i class="i_x_w"></i>
      </button>
      <div class="modal img_expansion">
        <Swiper
          :options="swiperOption"
          tag="ul"
          class="img_expansion_u swiper-wrapper"
          ref="multiImgSwiper"
        >
          <SwiperSlide v-for="(item, index) in urls" :key="index" tag="li">
            <ul class="img_expansion_ul">
              <li class="img_expansion_li">
                <pinch-zoom disable-zoom-control="disable" overflow="visible">
                  <img :src="item.imagePath" alt="" />
                </pinch-zoom>
              </li>
            </ul>
          </SwiperSlide>
        </Swiper>
      </div>
      <div class="swiper-pagination" v-show="isOpen"></div>
    </div>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import 'swiper/swiper.scss';

export default {
  name: 'MultipleImageModal',
  components: {
    Swiper,
    SwiperSlide,
  },
  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
    urls: {
      type: Array,
      default: () => [],
    },
    index: Number,
  },
  data() {
    return {
      imageClickIndex: 0,
      swiperOption: {
        pagination: {
          el: '.swiper-pagination',
        },
      },
    };
  },
  watch: {
    imageClickIndex() {
      if (this.imageClickIndex >= 0) {
        this.$refs.multiImgSwiper.$swiper.slideTo(this.imageClickIndex);
      }
    },
  },
};
</script>
<style scoped>
i {
  display: block;
  height: 100%;
}
</style>
